import type { CSSProperties, ReactNode } from "react";
import cx from "ui/cx";
import IconLoading from "ui/icons/IconLoading";
import styles from "./Loading.module.scss";

interface LoadingProps {
  variant?: "fullScreen" | "fill" | "icon";
  spinnerSize?: number;
  size?: "base" | "medium" | "large";
  text?: ReactNode;
  textPosition?: "above" | "below";
  direction?: "row" | "column";
  fill?: string;
  style?: CSSProperties;
  hideText?: boolean;
}

export default function Loading({
  variant,
  spinnerSize = 18,
  size = "base",
  text = "Loading",
  direction = "column",
  textPosition = "below",
  fill,
  style,
  hideText = false,
}: LoadingProps) {
  return (
    <div className={cx(styles.wrapper, styles[size], variant && styles[variant])} style={style}>
      <div className={cx(styles.content, styles[direction], textPosition && styles[textPosition])}>
        {!hideText && <div className={styles.text}>{text}</div>}
        <IconLoading size={spinnerSize} color="stoneDark" fill={fill} />
      </div>
    </div>
  );
}
